export default "__VITE_ASSET__BDzVSNUD__"